"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RemotionJobType = void 0;
var RemotionJobType;
(function (RemotionJobType) {
    RemotionJobType["ClipJob"] = "ClipJob";
    RemotionJobType["CeremonyJob"] = "CeremonyJob";
    RemotionJobType["LiveClipPreviewJob"] = "LiveClipPreviewJob";
})(RemotionJobType = exports.RemotionJobType || (exports.RemotionJobType = {}));
//# sourceMappingURL=remotion-job-type.js.map